<template>
    <v-item-group
        :model-value="modelValue"
        @update:model-value="onUpdate"
        mandatory
    >
        <v-row>
            <v-col cols="12">
                <v-item
                    v-slot="{ isSelected, toggle }"
                    :value="null"
                >
                    <v-btn
                        @click="toggle"
                        class="cursor-pointer"
                        :class="{ primary: modelValue === null }"
                        variant="text"
                        block
                    >
                        <span class="mr-4">No Answer</span>
                        <v-icon v-if="isSelected" :icon="mdiCheckboxMarked"></v-icon>
                        <v-icon v-else :icon="mdiCheckboxBlankOutline"></v-icon>
                    </v-btn>
                </v-item>
            </v-col>
        </v-row>
        <v-row class="flex-wrap" density="compact">
            <v-col
                cols="6"
                md="3"
                v-for="(bodyType, index) in bodyTypeList"
                :key="index"
            >
                <v-item
                    v-slot="{ isSelected, toggle }"
                    :value="bodyType.bodyType"
                >
                    <div
                        @click="toggle"
                        class="cursor-pointer"
                    >
                        <v-card
                            :color="isSelected ? 'primary' : 'accent'"
                            :variant="isSelected ? 'outlined' : 'plain'"
                        >
                            <v-img :src="`${cdnBasePathMain}${bodyType.imageUrl}`"></v-img>
                            <v-card-title
                                class="text-center justify-center pa-1"
                                :class="isSelected ? 'bg-primary' : 'bg-grey'"
                            >
                                {{ bodyType.text }}
                            </v-card-title>
                        </v-card>
                    </div>
                </v-item>
            </v-col>
        </v-row>
    </v-item-group>
</template>

<script lang="ts" setup>
    import { BodyTypeList } from '~/models';
    import {
        useCdnResource
    } from 'x1-base/composables';
    import { clone as lo_clone } from 'es-toolkit';
    import { mdiCheckboxMarked, mdiCheckboxBlankOutline } from '@mdi/js';

    defineProps({
        modelValue: {
            type: Number as PropType<Nilish<number>>,
            required: false,
            default: null
        },
        label: {
            type: String as PropType<string>,
            required: true
        }
    });

    const emit = defineEmits([
        'update:modelValue'
    ]);

    const useCdnResourceObj = useCdnResource();
    const bodyTypeList = lo_clone(BodyTypeList);
    const cdnBasePathMain = useCdnResourceObj.cdnBasePathMain;

    function onUpdate(newVal: Nilish<number>) {
        emit('update:modelValue', newVal);
    }
</script>

<style lang="scss" scoped></style>
